<template>
  <div class="new-page-main">
    <!--搜索查询栏-->
    <dt-search-bar style="padding: 20px 5px 5px">
      <template slot="filterSlot">
        <data-filter ref="dataFilterRef" :timeData="schoolTimeData" :schoolId="schoolId" :timesolt="1"
          :searchParams="searchParams" :contentObject="contentObject" :buttonColor="'#00CAAF'"
          @filter-data="filterData">
        </data-filter>
      </template>
      <template slot="addFilterSlot">
        <Select v-model="listFilters.typeId" ref="hwTypeRef" filterable placeholder="请选择题目类型"
          @on-change="changeDataDetailsIndex">
          <Option value="0">全部题目类型</Option>
          <Option v-for="item in quesTypeList" :value="item.queTypeId" :key="item.queTypeId">{{ item.queTypeName }}
          </Option>
        </Select>
      </template>
    </dt-search-bar>

    <div>
      <!--数据统计图-->
      <div class="data-statistics-img" ref="dataStatistics">
        <ul>
          <template v-for="(item, index) in dataSummaryMap">
            <data-statis-summary :num="item.value" :text="item.key" :key="item.key"
              :remindText="item.remindText"></data-statis-summary>
          </template>
        </ul>
      </div>
      <!--页面表格-->
      <div class="new-table-main-wrap" ref="tableMainRef">
        <div class="table-main">
          <!--教师列表-->
          <Table :columns="teaAnalyColumn" :data="teaAnalyList" :row-class-name="rowClassName" :loading="isLoading"
            v-if="type == 'teacher'"></Table>
          <!--班级列表-->
          <Table :columns="classAnalyColumn" :data="classAnalyList" :row-class-name="rowClassName" :loading="isLoading"
            v-else></Table>
        </div>
        <div class="bottom-page">
          <div class="laypage_main">
            <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
              v-if="pageParams.total && pageParams.pageCount > 1" show-total></Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInteractStatAPI,
  getInteractStatListAPI,
  getWholeStatAPI,
  getClsListStatAPI,
  getQueTypeStatAPI
} from "../../../../service/bigDataApi.js";
const DtSearchBar = () => import("../../../../components/DtSearchBar");
const DataFilter = () => import("../../../../components/DataFilter");
const DataStatisSummary = () =>
  import("../../../../components/DataStatisSummary");
export default {
  name: "new-data-list",
  components: {
    DtSearchBar,
    DataFilter,
    DataStatisSummary,
  },
  data() {
    return {
      //加载中
      isLoading: true,
      //各校时间切换按钮
      schoolTimeData: [
        {
          key: 0,
          value: "全部",
        },
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 3,
          value: "自定义",
        },
      ],
      //作业类型
      hwTypeList: [],
      searchParams: {
        classId:
          this.$route.params.classId == undefined
            ? "0"
            : this.$route.params.classId,
        gradeId:
          this.$route.params.gradeId == undefined
            ? "0"
            : this.$route.params.gradeId,
        subjectId:
          this.$route.params.subjectId == undefined
            ? "0"
            : this.$route.params.subjectId,
      },
      //数据概览集合
      dataSummaryMap: [],
      tabsName: 'teacher',
      contentObject: {
        //是否显示时间切换按钮
        displayTimeFilter: true,
        //是否显示学科下拉框
        displaySubjectFilter: true,
        //是否显示年级下拉框
        displayGradeFilter: false,
        //是否显示班级下拉框
        displayClassFilter: this.$route.query.type == 'teacher',
        //是否显示省份下拉框
        displayProvinceFilter: false,
        //是否显示城市下拉框
        displayCityFilter: false,
        //是否显示地区下拉框
        displayDistrictFilter: false,
      },
      schoolId: this.$route.query.schoolId,
      // 数据类型
      type: this.$route.query.type,
      // 教师id
      teacherId: this.$route.query.teacherId || '',
      // 班级id
      classId: this.$route.query.classId || '',
      // 年纪id
      gradeId: this.$route.query.gradeId || '',
      //列表参数
      listFilters: {
        keyWord:
          this.$route.params.filtersName == "0"
            ? ""
            : this.$route.params.filtersName,
        typeId: '0'
      },
      filters: {},
      pageParams: {
        page: 1,
        limit: 10,
        total: 0,
        pageCount: 0,
      },
      dataDetailStyle: {
        height: "850px",
      },
      searchHeight: "",
      //教师互动分析数据
      teaAnalyList: [],
      //教师互动分析列
      teaAnalyColumn: [
        {
          title: "所属班级",
          key: "className"
        },
        {
          title: "所授学科",
          key: "subjectName",
        },
        {
          title: "作业类型",
          key: "queTypeName",
        },
        {
          title: "接收人数",
          key: "receiveCount",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("0");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "接收人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "参与人数",
          key: "joinCount",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("1");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "参与人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "学生参与率",
          key: "joinRate",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("2");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "学生参与率"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
          render: (h, params) => {
            return h("div", this.$utils.toDecimal(params.row.joinRate).toString() + "%",);
          },
        },
      ],
      //班级互动分析数据
      classAnalyList: [],
      //班级互动分析列
      classAnalyColumn: [
        {
          title: "所属年级",
          key: "grdName",
        },
        {
          title: "所属学科",
          key: "subName",
        },
        {
          title: "所属类型",
          key: "typeName",
        },
        {
          title: "发布练习数",
          key: "workNum",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("workNum");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "发布练习数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "接收人数",
          key: "receiveNum",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("receiveNum");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "接收人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "参与人数",
          key: "submitNum",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("submitNum");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "参与人数"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
        },
        {
          title: "学生参与率",
          key: "submitRate",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  class: "sort-col",
                },
                on: {
                  click: () => {
                    this.sortData("submitRate");
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      cursor: "pointer",
                    },
                  },
                  "学生参与率"
                ),
                h("img", {
                  attrs: {
                    class: "sort-fun",
                    src: "/icon_change.png",
                  },
                  style: {
                    cursor: "pointer",
                  },
                }),
              ]
            );
          },
          render: (h, params) => {
            return h("div", this.$utils.toDecimal(params.row.submitRate).toString() + "%",);
          },
        },
      ],
      sortType: "2",
      order: "desc",
      dataStatis: [
        {
          key: "发布练习数",
          value: 0,
          remindText: "教师发布练习总数",
        },
        {
          key: "接收人数",
          value: 0,
          remindText: "每次练习学生接收人数总和",
        },
        {
          key: "参与人数",
          value: 0,
          remindText: "每次练习学生参与人数总和",
        },
        {
          key: "学生参与率",
          value: 0 + "%",
          remindText: "（参与人数/接收人数）*100%",
        }
      ],
      //题目类型列表
      quesTypeList: []
    };
  },
  created() {
    this.setCurrentPathArr();
  },
  methods: {
    /**
   * @name 获取题目类型列表
   */
    async getQueTypeStat() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId
      };
      await getQueTypeStatAPI(params)
        .then(function (data) {
          _this.quesTypeList = data;
        })
        .catch(function (error) {
          _this.$Message.error(error.message);
        });
    },
    /**
     * 设置面包屑
     */
    setCurrentPathArr() {
      let currentPathArr;
      let path = this.$route.query.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
        ? "cloudschooldataboard"
        : "schooldataboard"
      currentPathArr = [
        {
          title: "首页",
          path: path,
          name: path,
          params: {
            schoolId: this.$route.query.schoolId,
          },
          query: {
            // tokenId: this.$store.getters.token,
          },
        },
        {
          title: this.$route.query.schoolName,
          path: path,
          name: path,
          params: {
            schoolId: this.$route.query.schoolId,
          },
          query: {
            // tokenId: this.$store.getters.token,
          },
        },
        {
          title:
            this.type == "teacher"
              ? "教师答题互动分析"
              : "班级答题互动分析",
          path: "answeranalylist",
          name: "answeranalylist",
          query: {
            // tokenId: this.$store.getters.token,
            schoolId: this.$route.query.schoolId,
            schoolName: this.$route.query.schoolName,
            tabName: this.$route.query.type == 'teacher' ? 'teacher' : 'class',
          }
        },
        {
          title:
            this.type == "teacher"
              ? this.$route.query.teacherName
              : this.type == "grade" ? this.$route.query.gradeName : this.$route.query.className,
          path: "",
          name:
            this.type == "teacher"
              ? "teaAnswerAnalyDetails"
              : "classAnswerAnalyDetails",
        },
      ];
      this.$store.commit("setCurrentPath", currentPathArr);
    },
    /**
     * 导出产品信息
     */
    exportInfoToExcel() {
      let _this = this;
      //接口
      let link = "";
      let params = "";
      let value = "";
      switch (this.tabsName) {
        case "homework":
          link = "/stats/homeworks/grades/dashboard/detail/export";
          params = "&hwTypeCode=";
          value = this.listFilters.hwType;
          break;
        case "resource":
          link = "/stats/resource/exportUploadResourceData";
          params = "&isshare=";
          value =
            "&isShare=" + (this.listFilters.isShareResource == "-1"
              ? ""
              : this.listFilters.isShareResource);
          break;
        case "microClassKj":
          link = "/stats/resource/operation/list/export";
          params = "&isshare=";
          value =
            "&isshare=" + (this.listFilters.isShareResource == "-1"
              ? ""
              : this.listFilters.isShareResource);
          break;
        case "microClass":
          link = "/stats/microclass/operation/list/export";
          params = "&isshare=";
          value =
            "&isshare=" + this.listFilters.isShareMicro == "0"
              ? ""
              : this.listFilters.isShareMicro;
          break;
        case "inquiryLearning":
          link = "/stats/inquirystudy/operation/list/export";
          params = "";
          value = "";
          break;
      }
      let url = "";
      let subjectId = this.filters.subjectId == 0 ? "" : this.filters.subjectId;
      let gradeId = this.filters.gradeId == 0 ? (this.filters.phaseGradeIds || "") : this.filters.gradeId;
      let classId = this.filters.classId == 0 ? "" : this.filters.classId;
      if (this.tabsName == "resource") {
        url =
          process.env.VUE_APP_APIURL +
          link +
          "?schoolId=" +
          this.schoolId +
          "&resourceType=" +
          (this.listFilters.resourceType == '0' ? '' : this.listFilters.resourceType) +
          "&startDate=" +
          this.filters.startDate +
          "&endDate=" +
          this.filters.endDate +
          "&subjectId=" +
          subjectId +
          "&keyWord=" +
          this.listFilters.keyWord +
          "&pageno=" +
          this.pageParams.page +
          "&pagesize=" +
          this.pageParams.limit +
          params +
          value;
      } else {
        url =
          process.env.VUE_APP_APIURL +
          link +
          "?schoolid=" +
          this.schoolId +
          "&startdate=" +
          this.filters.startDate +
          "&enddate=" +
          this.filters.endDate +
          "&subjectid=" +
          subjectId +
          "&gradeid=" +
          gradeId +
          "&classid=" +
          classId +
          "&keyword=" +
          this.listFilters.keyWord +
          "&pageno=" +
          this.pageParams.page +
          "&pagesize=" +
          this.pageParams.limit +
          params +
          value;
      }
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      iframe.onload = function () {
        let msg = JSON.parse(iframe.contentDocument.body.innerText).msg;
        _this.$Message.error(msg);
        document.body.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    },
    /**
     * 筛选数据
     */
    filterData(filters, searchHeight) {
      this.filters = filters;
      this.searchHeight = searchHeight;
      this.changeDataDetailsIndex();
    },
    /**
     * 点击切换详细数据
     */
    changeDataDetailsIndex() {
      this.pageParams.page = 1;
      this.pageParams.total = 0;
      this.isLoading = true;
      this.queryDataByType();
      this.$nextTick(() => {
        this.dataDetailStyle.height =
          705 + this.$refs.dataStatistics.clientHeight + "px";
      });
    },
    /**
     * @name 根据不同的type请求数据
     */
    queryDataByType() {
      this.order = 'desc';
      this.dataSummaryMap = this.dataStatis;
      // 教师详情
      if (this.type == "teacher") {
        this.sortType = '2';
        this.getInteractStat();
        this.getSchoolInteractStatList();
      } else {
        // 班级年级详情
        this.sortType = 'workNum';
        this.getWholeStat();
        this.getClsListStat();
      }
    },
    /**
     * @name 获取教师答题互动统计
     */
    async getInteractStat() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
        startTime: _this.filters.startDate,
        endTime: _this.filters.endDate,
        subjectId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeId: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classId: _this.filters.classId == 0 ? "" : _this.filters.classId,
        teaId: _this.teacherId,
        typeId: _this.listFilters.typeId == '0' ? '' : _this.listFilters.typeId
      };
      let resultData = await getInteractStatAPI(params);
      _this.dataSummaryMap = [
        {
          key: "发布练习数",
          value: resultData.publishCount || 0,
          remindText: "教师发布练习总数",
        },
        {
          key: "接收人数",
          value: resultData.receiveCount || 0,
          remindText: "每次练习学生接收人数总和",
        },
        {
          key: "参与人数",
          value: resultData.joinCount || 0,
          remindText: "每次练习学生参与人数总和",
        },
        {
          key: "学生参与率",
          value:
            resultData.joinRate == null
              ? 0 + "%"
              : _this.$utils
                .toDecimal(resultData.joinRate)
                .toString() + "%",
          remindText: "（参与人数/接收人数）*100%",
        }
      ];
    },
    /**
     * @name 获取班级答题互动统计
     */
    async getWholeStat() {
      let _this = this;
      let params = {
        schId: _this.schoolId,
        sTime: _this.filters.startDate,
        eTime: _this.filters.endDate,
        clsId: _this.type == 'class' ? _this.classId : "",
        grdId: _this.type == 'grade' ? _this.gradeId : "",
        subId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        typeId: _this.listFilters.typeId == '0' ? '' : _this.listFilters.typeId
      };
      const resultData = await getWholeStatAPI(params);
      _this.dataSummaryMap = [
        {
          key: "发布练习数",
          value: resultData.workNum || 0,
          remindText: "教师发布练习总数",
        },
        {
          key: "接收人数",
          value: resultData.receiveNum || 0,
          remindText: "每次练习学生接收人数总和",
        },
        {
          key: "参与人数",
          value: resultData.submitNum || 0,
          remindText: "每次练习学生参与人数总和",
        },
        {
          key: "学生参与率",
          value:
            resultData.submitRate == null
              ? 0 + "%"
              : _this.$utils
                .toDecimal(resultData.submitRate)
                .toString() + "%",
          remindText: "（参与人数/接收人数）*100%",
        }
      ];
    },
    /**
     * @name 获取教师答题互动统计列表
     */
    async getSchoolInteractStatList() {
      let _this = this;
      let params = {
        schoolId: _this.schoolId,
        teaId: _this.teacherId,
        startTime: _this.filters.startDate,
        endTime: _this.filters.endDate,
        subjectId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        classId: _this.filters.classId == 0 ? "" : _this.filters.classId,
        page: _this.pageParams.page,
        limit: _this.pageParams.limit,
        keyWord: _this.listFilters.keyWord,
        typeId: _this.listFilters.typeId == '0' ? '' : _this.listFilters.typeId,
        order: _this.order,
        sortType: _this.sortType,
      };
      let resultData = await getInteractStatListAPI(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.teaAnalyList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.teaAnalyList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * @name 获取班级答题互动统计列表
     */
    async getClsListStat() {
      let _this = this;
      let params = {
        schId: _this.schoolId,
        sTime: _this.filters.startDate,
        eTime: _this.filters.endDate,
        clsId: _this.type == 'class' ? _this.classId : "",
        grdId: _this.type == 'grade' ? _this.gradeId : "",
        page: _this.pageParams.page,
        limit: _this.pageParams.limit,
        keyWord: _this.listFilters.keyWord,
        typeId: _this.listFilters.typeId == '0' ? '' : _this.listFilters.typeId,
        orderType: _this.order,
        order: _this.sortType,
        subId: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        typeId: _this.typeId
      };
      let resultData = await getClsListStatAPI(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      //隐藏加载中样式
      _this.isLoading = false;
      _this.classAnalyList = [];
      _this.pageParams.total = 0;
      if (Object.keys(resultData).length > 0) {
        _this.classAnalyList = resultData.rows;
        _this.pageParams.total = resultData.total_rows;
        _this.pageParams.pageCount = resultData.page_count;
        _this.$nextTick(() => {
          _this.dataDetailStyle.height =
            _this.searchHeight +
            _this.$refs.dataStatistics.clientHeight +
            _this.$refs.tableMainRef.clientHeight +
            30 +
            "px";
        });
      }
    },
    /**
     * 翻页
     */
    handleCurrentChange(val) {
      this.pageParams.page = val;
      this.isLoading = true;
      // 教师详情
      if (this.type == "teacher") {
        this.getSchoolInteractStatList();
      } else {
        // 班级年级详情
        this.getClsListStat();
      }
    },
    /**
     * 查询
     */
    handleSearch() {
      this.pageParams.total = 0;
      this.pageParams.page = 1;
      this.pageParams.pageCount = 0;
      this.isLoading = true;
      this.queryDataByType();
    },
    /**
     * @name 排序
     */
    sortData(currenSortType) {
      if (this.sortType == currenSortType) {
        this.order = this.order == 'desc' ? 'asc' : 'desc';
      } else {
        this.sortType = currenSortType;
        this.order = 'desc';
      }
      this.pageParams.page = 1;
      // 教师详情
      if (this.type == "teacher") {
        this.getSchoolInteractStatList();
      } else {
        // 班级年级详情
        this.getClsListStat();
      }
    },
    /**
     * 表格斑马纹
     */
    rowClassName(row, index) {
      if (index % 2 == 0) {
        return "ivu-table-stripe-even";
      } else return "ivu-table-stripe-odd";
    },

  },
  mounted() {
    this.getQueTypeStat();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../style/detailPage";

.circle-data {
  background: url("../../../../assets/images/databoard/detailPage/green-circle.png") top no-repeat;
}

.panel-box {
  background-image: url("../../../../assets/images/databoard/modal-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.big-data-search-btn {
  background: #00caaf !important;
  color: #fff;
  border-color: #00caaf !important;
}

/*图片预览遮罩层*/
.img-ml-box {
  position: fixed;
  top: 0px;
  height: 100%;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  z-index: 50;
  display: none;
}

/*遮罩层背景*/
.img-ml-box .img-ml-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  background: #000;
  opacity: 0.8;
  z-index: 55;
}

/*关闭按钮*/
.img-ml-box .img-ml-close {
  position: absolute;
  right: 15px;
  top: 10px;
  width: 32px;
  height: 32px;
  z-index: 999;
  opacity: 0.6;
  background: url("../../../../assets/images/databoard/close.png") center center no-repeat;
}

.img-ml-box .img-ml-close:hover {
  opacity: 1;
}

.audio-player-container {
  position: absolute;
  z-index: 70;
  top: 44%;
  left: 50%;
  width: 70%;
  max-width: 1200px;
  padding: 33px 80px 33px 156px;
  margin: 0 auto;
  display: block;
  background-color: #fff;
  border-radius: 5px;
  -webkit-transform: translate3d(-50%, -50%, 0);
  -moz-transform: translate3d(-50%, -50%, 0);
  -ms-transform: translate3d(-50%, -50%, 0);
  -o-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  display: none;
}

.audio-player-container .audio-progress {
  width: 100%;
  height: 24px;
  background: rgba(239, 241, 250, 1);
  border: 1px solid rgba(232, 234, 244, 1);
  border-radius: 12px;
  overflow: hidden;
}

.audio-player-container .audio-progress .audio-progress-bar {
  height: 100%;
  background: rgba(62, 115, 246, 1);
  border-radius: 12px;
}

.audio-player-container .play-btn {
  position: absolute;
  top: 21px;
  left: 71px;
  width: 50px;
  height: 50px;
  background: url("../../../../assets/images/databoard/icon-audioplayer.png") no-repeat;
  cursor: pointer;
}

.audio-player-container .play-btn:active {
  opacity: 0.6;
}

.audio-player-container .play-btn.play {
  background-position: 1px 1px;
}

.audio-player-container .play-btn.pause {
  background-position: 1px -64px;
}
</style>

<style lang="scss">
.new-data-tab-area {
  .ivu-tabs-bar {
    border-bottom: 0;
    background: #f2f5f3;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-nav-container {
    height: 40px;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    height: 40px;
    margin-right: 1px;
    padding: 9px 16px 4px;
  }

  .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    height: 40px;
    color: #00caaf;
  }

  .ivu-tabs-nav .ivu-tabs-tab:hover {
    color: #00caaf;
  }

  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
    border-color: #dcdee2 !important;
  }
}

.table-main {

  /*偶数行*/
  .ivu-table-stripe-even td {
    background-color: #fff !important;
  }

  /*奇数行*/
  .ivu-table-stripe-odd td {
    background-color: #fafbfd !important;
  }

  .ivu-table th {
    background-color: #f3f7f6;
    height: 50px !important;
    font-weight: bold;
  }

  .ivu-table td,
  .ivu-table th {
    border-bottom: 0;
  }

  .ivu-table:before {
    background-color: #efefef !important;
  }

  .ivu-table:after {
    background-color: #efefef !important;
  }

  .ivu-table-wrapper {
    border-top: 1px solid #efefef;
    border-left: 1px solid #efefef;
  }
}
</style>
